export default __webpack_public_path__ + "static/media/blog-101.737a14dc.jpg";